import { useEffect, useState } from 'react'
import { apiClient } from '@/lib/api'

export type PlatformBranding = {
  shop_id?: number
  name: string
  logo_url: string | null
  website_slug: string | null
  /** Public ShopQuay site URL from server FRONTEND_URL (no trailing slash). */
  website_url: string | null
}

const FALLBACK: PlatformBranding = {
  name: 'ShopQuay',
  logo_url: null,
  website_slug: null,
  website_url: null,
}

let cached: PlatformBranding | null = null
let inflight: Promise<PlatformBranding> | null = null

async function loadPlatformBranding(): Promise<PlatformBranding> {
  if (cached) return cached
  if (inflight) return inflight
  inflight = apiClient
    .get<{ success: boolean; data?: PlatformBranding }>('/platform/branding', {
      suppressErrorToast: true,
    })
    .then((res) => {
      const data = res?.data
      cached = {
        shop_id: data?.shop_id,
        name: data?.name || 'ShopQuay',
        logo_url: data?.logo_url || null,
        website_slug: data?.website_slug || null,
        website_url: data?.website_url?.replace(/\/$/, '') || null,
      }
      return cached
    })
    .catch(() => FALLBACK)
    .finally(() => {
      inflight = null
    })
  return inflight
}

export function usePlatformBranding(): PlatformBranding {
  const [branding, setBranding] = useState<PlatformBranding>(cached || FALLBACK)

  useEffect(() => {
    let cancelled = false
    void loadPlatformBranding().then((data) => {
      if (!cancelled) setBranding(data)
    })
    return () => {
      cancelled = true
    }
  }, [])

  return branding
}
